import type { Ordering } from "@/types/base";
import type { SnapshotGridQueryPayload } from "@/modules/snapshots/grid/gridQueryPayload";

export type SnapshotViewAccess = "restricted" | "public";
export type SnapshotViewSortField = "name" | "access" | "created_at" | "updated_at" | "hierarchy";
export type SnapshotViewDynamicDatePreset =
  | "current_month"
  | "previous_month"
  | "current_quarter"
  | "current_year"
  | "last_30_days";

export type SnapshotViewDateRange =
  | {
      mode: "fixed";
      field_key: string;
      start_date: string | null;
      end_date: string | null;
      preset: null;
    }
  | {
      mode: "dynamic";
      field_key: string;
      start_date: null;
      end_date: null;
      preset: SnapshotViewDynamicDatePreset;
    };

export interface SnapshotViewConfiguration {
  schema_version: 1;
  column_order: string[];
  hidden_column_keys: string[];
  column_filters: Record<string, unknown>;
  date_range: SnapshotViewDateRange | null;
  ordering: Ordering;
}

export interface SnapshotView {
  id: string;
  name: string;
  snapshot_collection_id: string;
  snapshot_collection_name: string | null;
  template_id: string | null;
  template_name: string | null;
  owner_id: string;
  organization_id: string;
  access: SnapshotViewAccess;
  configuration: SnapshotViewConfiguration;
  revision: number;
  created_at: string;
  updated_at: string;
}

export interface SnapshotViewCollectionGroup {
  id: string;
  name: string;
  viewCount: number;
  views: SnapshotView[];
}

export interface SnapshotViewTemplateGroup {
  id: string;
  name: string;
  viewCount: number;
  collections: SnapshotViewCollectionGroup[];
}

export interface SnapshotViewListResponse {
  items: SnapshotView[];
  total: number;
}

export interface SnapshotViewGridQueryPayload {
  configuration: SnapshotViewConfiguration;
  offset: number;
  limit: number;
  query: string;
}

export const snapshotViewGridPayload = (
  query: SnapshotGridQueryPayload,
  configuration: SnapshotViewConfiguration,
): SnapshotViewGridQueryPayload => ({
  configuration,
  offset: query.offset,
  limit: query.limit,
  query: query.query,
});
